import * as React from "react";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";

export const MegamenuLink = ({
    children,
    hasSubLinks = false,
    subItem,
    onLinkClick = () => {},
    settings,
    level = 1,
    icon = '',
}) => {
    // Extract title class if it's in the format "Title | class"
    const titleText = useNavigationParse(subItem.title);
    const isTitle = titleText.classes && titleText.classes.includes('title');
    
    // Get level-specific styles for links and titles
    const getLevelSpecificStyle = () => {
        return {
            // Link styling based on level
            linkStyle: isTitle 
                ? settings.section[`level${level}_title_style`] || settings.section.title_style || 'h4' 
                : settings.section[`level${level}_link_style`] || settings.section.link_style || 'b2',
            
            // Icon styling
            iconStyle: {
                color: settings.section[`level${level}_icon_color`] || 'inherit',
                fontSize: settings.section[`level${level}_icon_size`]
                    ? `${settings.section[`level${level}_icon_size`]}px`
                    : 'inherit',
                marginRight: settings.section[`level${level}_icon_spacing`]
                    ? `${settings.section[`level${level}_icon_spacing`]}px`
                    : '0'
            },
            
            // Hover effects
            hoverClass: settings.section[`level${level}_hover_effect`] || '',
            
            // Active state
            activeClass: settings.section[`level${level}_active_class`] || 'font-medium',
            
            // Container styling
            containerStyles: {
                padding: settings.section[`level${level}_item_padding`]
                    ? `${settings.section[`level${level}_item_padding`]}px`
                    : '0',
                borderRadius: settings.section[`level${level}_item_radius`]
                    ? `${settings.section[`level${level}_item_radius`]}px`
                    : '0',
                backgroundColor: settings.section[`level${level}_item_bg`] || 'transparent',
            },
        };
    };
    
    const styleObj = getLevelSpecificStyle();
    const spanClass = isTitle ? "megamenu__title" : "megamenu__link";
    
    // Generate arrow icon based on settings
    const getArrowIcon = () => {
        // Default to chevron-right if not specified
        const iconName = settings.section[`level${level}_arrow_icon`] || 'icon-chevron-right';
        const styles = settings.section[`level${level}_show_arrow_icon_on_hover`] ? 'opacity-0 transition-all' : '';

        return (
            <span className="arrow-icon flex-shrink-0">
                <i 
                    className={`icon ${iconName} ${styles}`}
                    style={styleObj.iconStyle}
                ></i>
            </span>
        );
    };

    const classes = settings.section[`level${level}_show_arrow_icon_on_hover`] ? 'show-icon-on-hover' : '';

    return (
        <li className={`w-full ${classes}`} style={styleObj.containerStyles}>
            {!isTitle ? (
                <a 
                    href={subItem.url} 
                    className={`flex items-center gap-3 w-full ${styleObj.linkStyle} ${styleObj.hoverClass}`}
                    onClick={onLinkClick}
                >
                    {icon && 
                        <span className="flex-shrink-0">
                            <i 
                                className={icon}
                                style={styleObj.iconStyle}
                            />
                        </span>
                    }

                    <span className={`${spanClass} flex-1`}>
                        {titleText.icon && (
                            <i 
                                className={`icon ${titleText.icon} mr-2`} 
                                style={styleObj.iconStyle}
                            ></i>
                        )}
                        {titleText.text}
                    </span>

                    {(hasSubLinks || settings.section[`level${level}_show_arrow_icon_on_hover`]) && getArrowIcon()}
                </a>
            ) : (
                <div className="w-full">
                    <span className={`${styleObj.linkStyle} ${spanClass}`}>
                        {titleText.icon && (
                            <i 
                                className={`icon ${titleText.icon} mr-2`}
                                style={styleObj.iconStyle}
                            ></i>
                        )}
                        {titleText.text}
                    </span>
                </div>
            )}
            {children}
        </li>
    );
};

